import { useEffect, useRef, useState } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useDispatchApp, useSelectorApp } from "../lib/redux";
import { Helmet } from "react-helmet";
import { CssBaseline } from "@mui/material";
import Login from "../pages/Login/Login";
import LoginOwner from "../pages/LoginOwner/LoginOwner";
import Trial from "../pages/Trial/Trial";
import { PublicRoute } from "./routes/PublicRoute";
import {
  FONT_SIZE_BUTTON,
  IS_ADLE_DOMAIN,
  IS_WHITE_LABEL_BRAND,
  ROLES_ALLOWED,
  THEME_ID_PROJECT,
} from "../utils/constants";
import { auth } from "../lib/firebase";
import { onAuthStateChanged } from "firebase/auth";
import {
  checkingFinish,
  getPathDatabaseByRole,
  isAdminDomain,
  isLoginInProgress,
  login,
  startLogout,
  validateConnectionByRole,
} from "../actions/auth";
import { buildAuthUserPayload } from "../utils/authToken";
import Loader from "../components/Loaders/Loader";
import { PrivateRoute } from "./routes/PrivateRoute";
import { OwnerRoute } from "./routes/OwnerRoute";
import Register from "../pages/Register/Register";
import {
  startGetIntegrations,
  startGetLastSelectedIntegrationData,
  startGetTotalMetricsUser,
} from "../actions/user";
import GeneralLayout from "../components/Layouts/GeneralLayout";
import {
  startGetLastDateTimeInsights,
  startGetTheme,
  startGetVersionAds,
} from "../actions/ui";
import { startListenerAgenciesFeatureFlags } from "../actions/agenciesFeatureFlags";
import ModalBlockVersionApp from "../components/Modal/ModalBlockVersionApp";
import ModalRebrandAdle from "../components/Modal/ModalRebrandAdle";
import { off } from "firebase/database";
import {
  startGetPlansAds,
  startGetLinkedInPostShared,
  startGetStripeInfo,
  startGetSubscriptionPlan,
  startGetSubscriptionPlanInfoUsage,
  startListenerBrandUsageAllocation,
  startListenerBrandUsageConsumed,
  startGetTypeOfPlans,
  startListenerIsActivePlan,
  startListenerSubscriptionPlanInfo,
  startGetSubscriptionPlanInfo,
  setIsPlanActiveResolved,
} from "../actions/payments";
import { startLoadCreditActionCosts } from "../actions/creditActionCosts";
import { startListenerByokConfiguration } from "../actions/byok";
import { startGetAllChats } from "../actions/chat";
import ModalPaySubscription from "../components/Modal/ModalPaySubscription/ModalPaySubscription";
import ModalPurchaseCredits from "../components/Modal/ModalPurchaseCredits/ModalPurchaseCredits";
import { setModalOpenState } from "../actions/ui";
import ModalConfigureBrandLimits from "../components/Modal/ModalConfigureBrandLimits";
import { PHProvider } from "../contexts/PostHogContext";
import PostHogPageView from "../components/Containers/PostHogPageView";
import "@formatjs/intl-displaynames/polyfill";
import "@formatjs/intl-displaynames/locale-data/en";
import "@formatjs/intl-displaynames/locale-data/es";
import { usePostHog } from "posthog-js/react";
import VerifyAuth from "../pages/VerifyAuth/VerifyAuth";
import OwnerLoginAs from "../pages/OwnerLoginAs/OwnerLoginAs";
import _ from "lodash";
import useUserIP from "../hooks/useUserIP";
import AdsCampaignStatistics from "../pages/AdsCampaignStatistics/AdsCampaignStatistics";
import GlobalReport from "../pages/GlobalReport/GlobalReport";
import Error404 from "../pages/Error404/Error404";
import ModalIntegrationNotFound from "../components/Modal/ModalIntegrationNotFound/ModalIntegrationNotFound";
import Paywall from "../pages/Paywall/Paywall";
import NewAdsCampaign from "../pages/NewAdsCampaign/NewAdsCampaign";
import Settings from "../pages/Settings/Settings";
import {
  startGetAdsCampaignsIDsByAgency,
  startGetUserHideMetricsAlert,
  startSaveSessionDataUser,
} from "../actions/adsCampaigns";
import AdsCampaigns from "../pages/AdsCampaigns/AdsCampaigns";
import Dashboard from "../pages/Dashboard/Dashboard";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import CompleteRegistration from "../pages/CompleteRegistration/CompleteRegistration";
import BillingAndPayments from "../pages/BillingAndPayments/BillingAndPayments";
import { AdvertiserProvider } from "../contexts/AdvertiserContext";
import { ContentModalsProvider } from "../contexts/ContentModalsProvider";
import {
  TemplatesModalsProvider,
  TemplatesModalsStack,
} from "../contexts/TemplatesModalsProvider";
import NpsForm from "../components/Alerts/NpsForm";
import { useTrialManagement } from "../hooks/useTrialManagement";
import ModalWelcome from "../components/Modal/ModalWelcome";
import Backdrop from "../components/Loaders/Backdrop";
import AdminDashboard from "../pages/AdminDashboard/AdminDashboard";
import OwnerLayout from "../pages/AdminDashboard/OwnerLayout";
import OwnerFormSubmissionsBrief from "../pages/AdminDashboard/OwnerFormSubmissionsBrief";
import PreActivationOwnerReview from "../pages/PreActivation/PreActivationOwnerReview";
import GlobalNotificationsPanel from "../components/Alerts/GlobalNotificationsPanel";
import PanelStorageFull from "../components/Alerts/PanelStorageFull";
import useTidio from "../hooks/useTidio";
import { useEmailUnsubscribeQueryAlert } from "../hooks/useEmailUnsubscribeQueryAlert";
import { usePlatformOAuthCallback } from "../hooks/usePlatformOAuthCallback";
import PreActivation, {
  getBrowserLanguage,
} from "../pages/PreActivation/PreActivation";
import EnterpriseIntake, {
  getBrowserLanguage as getEnterpriseBrowserLanguage,
} from "../pages/EnterpriseIntake/EnterpriseIntake";
import EnterpriseIntakeOwnerReview from "../pages/EnterpriseIntake/EnterpriseIntakeOwnerReview";
import AppSumoCallback from "../pages/AppSumoCallback/AppSumoCallback";
import AppSumoRegister from "../pages/AppSumoRegister/AppSumoRegister";
import ReportedContentBrief from "../pages/AdminDashboard/ReportedContentBrief";
import OwnerPromotionalCodesBrief from "../pages/AdminDashboard/OwnerPromotionalCodesBrief";
import CampaignApproval from "../pages/CampaignApproval/CampaignApproval";
import ContentApproval from "../pages/ContentApproval/ContentApproval";
// import WhatsAppChatSimulator from "../pages/WhatsAppChatSimulator/WhatsAppChatSimulator";
import MicaConnectPage from "../pages/MicaConnect/MicaConnectPage";
import MicaRedirectPage from "../pages/MicaRedirect/MicaRedirectPage";
import TemplatesLegacyRedirect from "../components/Templates/TemplatesLegacyRedirect";

const STANDALONE_FORM_PREFIXES = [
  "/pre-activation",
  "/enterprise-intake",
  "/campaign-approval",
  "/content-approval",
  "/whatsapp-chat-simulator",
  "/redirect-mica",
  "/mica",
];

const isStandaloneFormPath = (pathname) =>
  STANDALONE_FORM_PREFIXES.some((prefix) => pathname.startsWith(prefix));

const AppContent = () => {
  const { showWelcomeModal, onCloseWelcomeModal } = useTrialManagement();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingRequiredData, setIsLoadingRequiredData] = useState(true);
  const [versionApp] = useState("1.4.13");
  const isPlanActiveListenerRef = useRef(null);
  const [adsCampaignsIDsByAgencyListener, setAdsCampaignsIDsByAgencyListener] =
    useState(null);
  const [chatsListener, setChatsListener] = useState(null);
  const [subscriptionPlanListener, setSubscriptionPlanListener] =
    useState(null);
  const [subscriptionPlanInfoListener, setSubscriptionPlanInfoListener] =
    useState(null);
  const [byokConfigurationListener, setByokConfigurationListener] =
    useState(null);
  const [brandUsageAllocationListener, setBrandUsageAllocationListener] =
    useState(null);
  const [brandUsageConsumedListener, setBrandUsageConsumedListener] =
    useState(null);

  const { user, isLoading: isLoadingAuth } = useSelectorApp(
    (state) => state.auth
  );
  useUserIP();
  useTidio();
  useEmailUnsubscribeQueryAlert();
  const platformOAuthBackdrop = usePlatformOAuthCallback();

  const dispatch = useDispatchApp();
  const theme = useSelectorApp((state) => state.ui.theme);
  const version = useSelectorApp((state) => state.ui.version);
  const subscriptionPlan = useSelectorApp(
    (state) => state.payments?.subscriptionPlan
  );
  const isModalPurchaseCredits = useSelectorApp(
    (state) => state.ui?.openModals?.isModalPurchaseCredits
  );
  const isModalConfigureBrandLimits = useSelectorApp(
    (state) => state.ui?.openModals?.isModalConfigureBrandLimits
  );
  const isOpenVersionBlock = versionApp !== version;
  const { userID, agencyID } = dispatch(getPathDatabaseByRole());

  const postHog = usePostHog();
  const location = useLocation();
  const isStandaloneForm = isStandaloneFormPath(location.pathname);
  const layoutShowsAppChrome = Boolean(user) && !isStandaloneForm;
  const shouldWaitForUserData = Boolean(user) && !isStandaloneForm;

  const excludedRoutes = [
    "/login",
    "/get-started",
    "/trial",
    "/verify-auth",
    "/owner-login-as",
    "/reset-password",
    "/complete-registration",
    "/dashboard",
    "/leads",
    "/promotional-codes",
    "/appSumo/callback",
    "/appSumo/register",
  ];

  const shouldShowNotificationsPanel =
    !isStandaloneForm &&
    !excludedRoutes.includes(location.pathname) &&
    !location.pathname.startsWith("/dashboard") &&
    !location.pathname.startsWith("/leads") &&
    !location.pathname.startsWith("/promotional-codes");

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdTokenResult();
        if (!ROLES_ALLOWED.includes(token.claims.role)) {
          const isUserRegisteredAndHasClaims = token.claims?.role;
          const providerID = user?.providerData?.[0]?.providerId;
          const isProviderPhone = providerID === "phone";
          const isProviderGoogle = providerID === "google.com";
          const isAnonymous = user.isAnonymous;

          if (
            (!isProviderPhone && !isProviderGoogle && !isAnonymous) ||
            isUserRegisteredAndHasClaims
          ) {
            auth.signOut();
            await dispatch(startLogout());
            postHog.reset();
          }
          setIsLoading(false);
          dispatch(checkingFinish());
        } else {
          if (isLoginInProgress()) {
            return;
          }

          const validation = validateConnectionByRole(token.claims.role);
          if (!validation.ok) {
            auth.signOut();
            await dispatch(startLogout());
            postHog.reset();
            setIsLoading(false);
            dispatch(checkingFinish());
          } else {
            const userData = buildAuthUserPayload(user, token);
            dispatch(login(userData));
            const { userID } = dispatch(getPathDatabaseByRole(userData));

            postHog.identify(user.uid, {
              email: user.email,
              name: token.claims.name || user.displayName,
              role: token.claims?.role,
              companyID: userID,
            });
            postHog.group("company", userID);
          }
        }
      } else {
        await dispatch(startLogout());
        postHog.reset();
        dispatch(checkingFinish());
        setIsLoading(false);
      }
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    onClearListeners();
    if (!user?.uid) {
      return;
    }

    dispatch(setIsPlanActiveResolved(false));
    getInitialData();

    return () => {
      onClearListeners();
    };
    //eslint-disable-next-line
  }, [user?.uid, userID]);

  useEffect(() => {
    getRequiredData();
    //eslint-disable-next-line
  }, []);

  const getRequiredData = async () => {
    await dispatch(startGetVersionAds());
    await dispatch(startGetLastDateTimeInsights());
    dispatch(startListenerAgenciesFeatureFlags());
    if (!_.isEmpty(THEME_ID_PROJECT)) {
      await dispatch(startGetTheme());
    }
    setIsLoadingRequiredData(false);
  };

  const getInitialData = async () => {
    await dispatch(startLoadCreditActionCosts());
    dispatch(startGetTotalMetricsUser());
    await dispatch(startGetTypeOfPlans());
    await dispatch(startGetLinkedInPostShared());
    await dispatch(
      startGetSubscriptionPlanInfoUsage((ref) => {
        setSubscriptionPlanListener(ref);
      })
    );
    await dispatch(startGetSubscriptionPlanInfo());
    dispatch(
      startListenerSubscriptionPlanInfo((refSubscriptionPlanInfo) => {
        setSubscriptionPlanInfoListener(refSubscriptionPlanInfo);
      })
    );
    await dispatch(
      startListenerIsActivePlan((refIsPlanActive) => {
        isPlanActiveListenerRef.current = refIsPlanActive;
      })
    );
    dispatch(startGetPlansAds());
    dispatch(startGetUserHideMetricsAlert());
    await dispatch(startGetIntegrations());
    await dispatch(startGetLastSelectedIntegrationData());
    await dispatch(startGetSubscriptionPlan());
    dispatch(startSaveSessionDataUser());
    dispatch(startGetStripeInfo());
    dispatch(
      startGetAllChats((refChats) => {
        setChatsListener(refChats);
      })
    );
    dispatch(
      startGetAdsCampaignsIDsByAgency((ref) => {
        setAdsCampaignsIDsByAgencyListener(ref);
      })
    );
    dispatch(
      startListenerByokConfiguration((ref) => {
        setByokConfigurationListener(ref);
      })
    );
    dispatch(
      startListenerBrandUsageAllocation((ref) => {
        setBrandUsageAllocationListener(ref);
      })
    );
    dispatch(
      startListenerBrandUsageConsumed((ref) => {
        setBrandUsageConsumedListener(ref);
      })
    );
    setIsLoading(false);
  };
  const onClearListeners = () => {
    if (isPlanActiveListenerRef.current) {
      off(isPlanActiveListenerRef.current);
      isPlanActiveListenerRef.current = null;
    }
    if (chatsListener) {
      off(chatsListener);
    }
    if (subscriptionPlanListener) {
      off(subscriptionPlanListener);
    }
    if (subscriptionPlanInfoListener) {
      off(subscriptionPlanInfoListener);
    }
    if (adsCampaignsIDsByAgencyListener) {
      off(adsCampaignsIDsByAgencyListener);
    }
    if (byokConfigurationListener) {
      off(byokConfigurationListener);
    }
    if (brandUsageAllocationListener) {
      off(brandUsageAllocationListener);
    }
    if (brandUsageConsumedListener) {
      off(brandUsageConsumedListener);
    }
  };

  window.NAME_BUSINESS = theme.nameBusiness;
  window.buttonPrimaryColor = theme.palette.button.primary.main;
  window.buttonPrimaryContrastText = theme.palette.button.primary.contrastText;
  window.buttonPrimaryHover = theme.palette.button.primary.hover.main;
  window.buttonPrimaryHoverContrastText =
    theme.palette.button.primary.hover.contrastText;
  window.buttonSecondaryColor = theme.palette.button.secondary.main;
  window.buttonSecondaryContrastText =
    theme.palette.button.secondary.contrastText;
  window.buttonSecondaryHover = theme.palette.button.secondary.hover.main;
  window.buttonSecondaryHoverContrastText =
    theme.palette.button.secondary.hover.contrastText;
  window.primaryColor = theme.palette.primary.main;
  window.secondaryColor = theme.palette.secondary.main;
  window.textPrimaryColor = theme.palette.primary.contrastText;
  window.textSecondaryColor = theme.palette.secondary.contrastText;
  window.paper = theme.palette.background.paper;
  window.paperContrastText = theme.palette.background.paperContrastText;
  window.paperSecondary = theme.palette.background.paperSecondary;
  window.paperSecondaryContrastText =
    theme.palette.background.paperSecondaryContrastText;
  window.fontSizeButton = `${FONT_SIZE_BUTTON}px`;
  document.documentElement.style.setProperty(
    "--primary-color",
    theme.palette.primary.main
  );
  document.documentElement.style.setProperty(
    "--secondary-color",
    theme.palette.secondary.main
  );
  document.documentElement.style.setProperty(
    "--text-primary-color",
    theme.palette.primary.contrastText
  );
  document.documentElement.style.setProperty(
    "--text-secondary-color",
    theme.palette.secondary.contrastText
  );
  document.documentElement.style.setProperty(
    "--paper",
    theme.palette.background.paper
  );
  document.documentElement.style.setProperty(
    "--paper-contrast-text",
    theme.palette.background.paperContrastText
  );
  document.documentElement.style.setProperty(
    "--paper-secondary",
    theme.palette.background.paperSecondary
  );
  document.documentElement.style.setProperty(
    "--paper-secondary-contrast-text",
    theme.palette.background.paperSecondaryContrastText
  );
  document.documentElement.style.setProperty(
    "--hover-main",
    theme.palette.hover.main
  );
  document.documentElement.style.setProperty(
    "--font-family",
    theme.typography.fontFamily
  );

  if (
    isLoadingAuth ||
    !version ||
    isLoadingRequiredData ||
    (shouldWaitForUserData && isLoading)
  ) {
    return <Loader fullScreen fullWidth />;
  }

  return (
    <>
      <Helmet>
        <title>{`${theme.nameBusiness}`}</title>
        <link rel="icon" href={theme.favicon} />
        <link rel="apple-touch-icon" href={theme.favicon} />
      </Helmet>
      <CssBaseline />
      <TemplatesModalsProvider>
      <ContentModalsProvider>
      <GeneralLayout isLogged={layoutShowsAppChrome}>
        <PHProvider>
          {!isStandaloneForm ? <NpsForm /> : null}
          <PostHogPageView />
          <AdvertiserProvider>
            <Backdrop />
            {platformOAuthBackdrop}
            <Routes>
              <Route path="*" element={<Error404 />} />
              <Route
                path="/login"
                element={
                  <PublicRoute restricted={true} isLogged={user ? true : false}>
                    {isAdminDomain() ? <LoginOwner /> : <Login />}
                  </PublicRoute>
                }
              />

              <Route
                path="/get-started"
                element={
                  <PublicRoute restricted={true} isLogged={user ? true : false}>
                    <Register />
                  </PublicRoute>
                }
              />

              <Route
                path="/start-trial"
                element={
                  <PublicRoute restricted={true} isLogged={user ? true : false}>
                    <Trial />
                  </PublicRoute>
                }
              />

              <Route
                path="/"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/campaigns"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <AdsCampaigns />
                  </PrivateRoute>
                }
              />
              <Route
                path="/templates"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <TemplatesLegacyRedirect kind="list" />
                  </PrivateRoute>
                }
              />
              <Route
                path="/template"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <TemplatesLegacyRedirect kind="editor" />
                  </PrivateRoute>
                }
              />
              <Route
                path="/produce"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <TemplatesLegacyRedirect kind="produce" />
                  </PrivateRoute>
                }
              />
              <Route
                path="/ads-campaign"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <NewAdsCampaign />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <GlobalReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/ads-campaign-statistics"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <AdsCampaignStatistics />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <Settings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/billing"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <BillingAndPayments />
                  </PrivateRoute>
                }
              />
              <Route
                path="/paywall"
                element={
                  <PrivateRoute
                    restricted={false}
                    isLogged={user ? true : false}
                    verifyTrial={false}
                  >
                    <Paywall />
                  </PrivateRoute>
                }
              />
              <Route
                path="/verify-auth"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <VerifyAuth />
                  </PublicRoute>
                }
              />
              <Route
                path="/owner-login-as"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <OwnerLoginAs />
                  </PublicRoute>
                }
              />
              <Route
                path="/appSumo/callback"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <AppSumoCallback />
                  </PublicRoute>
                }
              />
              <Route
                path="/appSumo/register"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <AppSumoRegister />
                  </PublicRoute>
                }
              />
              <Route
                path="/pre-activation"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <Navigate
                      to={`/pre-activation/${getBrowserLanguage()}`}
                      replace
                    />
                  </PublicRoute>
                }
              />
              <Route
                path="/pre-activation/:lang"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <PreActivation />
                  </PublicRoute>
                }
              />
              <Route
                path="/enterprise-intake"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <Navigate
                      to={`/enterprise-intake/${getEnterpriseBrowserLanguage()}`}
                      replace
                    />
                  </PublicRoute>
                }
              />
              <Route
                path="/enterprise-intake/:lang"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <EnterpriseIntake />
                  </PublicRoute>
                }
              />
              <Route
                path="/campaign-approval"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <CampaignApproval />
                  </PublicRoute>
                }
              />
              <Route
                path="/content-approval"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <ContentApproval />
                  </PublicRoute>
                }
              />
              <Route
                path="/redirect-mica"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <MicaRedirectPage />
                  </PublicRoute>
                }
              />
              {/* <Route
                path="/whatsapp-chat-simulator"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <WhatsAppChatSimulator />
                  </PublicRoute>
                }
              /> */}
              <Route
                path="/mica/connect/:platform"
                element={
                  <PublicRoute
                    restricted={false}
                    isLogged={user ? true : false}
                  >
                    <MicaConnectPage />
                  </PublicRoute>
                }
              />
              <Route
                path="/mica/connect"
                element={<Navigate to="/mica/connect/meta" replace />}
              />
              <Route
                path="/reset-password"
                element={
                  <PublicRoute restricted={true} isLogged={user ? true : false}>
                    <ResetPassword />
                  </PublicRoute>
                }
              />
              <Route
                path="/complete-registration"
                element={
                  <PublicRoute restricted={true} isLogged={user ? true : false}>
                    <CompleteRegistration />
                  </PublicRoute>
                }
              />
              <Route
                element={
                  <OwnerRoute isLogged={user ? true : false}>
                    <OwnerLayout />
                  </OwnerRoute>
                }
              >
                <Route path="/dashboard" element={<AdminDashboard />} />
                <Route path="/leads" element={<OwnerFormSubmissionsBrief />} />
                <Route
                  path="/promotional-codes"
                  element={<OwnerPromotionalCodesBrief />}
                />
                <Route
                  path="/report-content"
                  element={<ReportedContentBrief />}
                />
                <Route
                  path="/leads/:formId"
                  element={<PreActivationOwnerReview />}
                />
                <Route
                  path="/enterprise-leads/:formId"
                  element={<EnterpriseIntakeOwnerReview />}
                />
              </Route>
            </Routes>
            {!IS_ADLE_DOMAIN && !IS_WHITE_LABEL_BRAND && <ModalRebrandAdle />}
            {isOpenVersionBlock && (
              <ModalBlockVersionApp modalOpen={isOpenVersionBlock} />
            )}

            <ModalPaySubscription />
            {!!subscriptionPlan && isModalPurchaseCredits && (
              <ModalPurchaseCredits
                modalOpen={Boolean(isModalPurchaseCredits)}
                onCloseModal={() =>
                  dispatch(setModalOpenState("isModalPurchaseCredits", false))
                }
              />
            )}
            {isModalConfigureBrandLimits ? (
              <ModalConfigureBrandLimits
                modalOpen={Boolean(isModalConfigureBrandLimits)}
                agencyID={agencyID}
                onCloseModal={() =>
                  dispatch(
                    setModalOpenState("isModalConfigureBrandLimits", false)
                  )
                }
              />
            ) : null}
            <ModalIntegrationNotFound />
            {shouldShowNotificationsPanel && <GlobalNotificationsPanel />}
            <PanelStorageFull />
          </AdvertiserProvider>
        </PHProvider>
      </GeneralLayout>

      {!isStandaloneForm ? (
        <ModalWelcome
          modalOpen={showWelcomeModal}
          onCloseModal={onCloseWelcomeModal}
        />
      ) : null}
      <TemplatesModalsStack />
      </ContentModalsProvider>
      </TemplatesModalsProvider>
    </>
  );
};

const AppRouter = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

export default AppRouter;
